/**
 * @fileoverview Input/output schemas for the character-extractor-targeted-v2 agent.
 *
 * This agent extracts specific character(s) by name from text,
 * using the same output format as the full character extractor.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { CharacterV2IdeaSchema } from '@/domains/characters/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The text to analyze for character information.'),
  targetCharacterNames: z.array(z.string()).describe('The specific character name(s) to extract from the text.'),
}).merge(AGENT_SCHEMA_OBJECTS.storyContext.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  characters: z.array(CharacterV2IdeaSchema).describe('An array of extracted characters matching the target names.'),
});

export type Output = z.infer<typeof OutputSchema>;
